export const GAME_WIDTH = 640;
export const GAME_HEIGHT = 360;
export const TILE = 24;
export const LEVEL_ROWS = 15;
export const GROUND_ROW = 13;
export const HUD_HEIGHT = 42;
export const SCALE = TILE / 16;

export const scaleFromNes = (value: number): number => Math.round(value * SCALE);
